import React, { useEffect, useState } from "react";
import { HttpStatusCode } from "axios";

import { BuildingId } from "../../../types/building";

import {
  getIncommodityCategoryList,
  IncommodityCategoryListRequest,
  IncommodityCategoryGroup,
  IncommodityCategory,
} from "../../../services/centerServices";

import CommonButton from "../../Button";
import CommonPopup from "../../Popup";

type Props = BuildingId & {
  onSelect: (category: IncommodityCategory) => void;
};

export default function CategoryList({ buildingId, onSelect }: Props) {
  const [categoryList, setCategoryList] = useState<IncommodityCategoryGroup>(
    {}
  );
  const [active, setActive] = useState<boolean>(false);

  useEffect(() => {
    const getDefaultCategoryListWrapper = async () => {
      const { status, data } = await getIncommodityCategoryList({
        buildingId,
      } as IncommodityCategoryListRequest);
      if (status === HttpStatusCode.Ok) {
        setCategoryList(data);
      }
    };

    getDefaultCategoryListWrapper();
  }, [buildingId]);

  return (
    <div className="flex flex-col px-4 pb-2 w-full">
      <CommonButton
        variant="tertiary"
        className="text-sm font-medium leading-[17px] text-brand-neutral-60 h-[50px]"
        onClick={() => {
          setActive((prev) => !prev);
        }}
      >
        카테고리 전체 보기
      </CommonButton>
      <CommonPopup
        title="카테고리 전체"
        isOpen={active}
        onClose={() => setActive(false)}
      >
        <div className="flex flex-col gap-5">
          {Object.entries(categoryList).map(([value, categoryList]) => (
            <div className="flex flex-col gap-2.5" key={value}>
              <span className="py-2.5 text-base font-semibold leading-[19px]">
                {value}
              </span>
              <div className="flex flex-wrap gap-2.5">
                {categoryList.map((category) => (
                  <CommonButton
                    variant="default2"
                    key={category?.serviceTemplateId}
                    onClick={() => onSelect(category)}
                  >
                    {category?.serviceName}
                  </CommonButton>
                ))}
              </div>
            </div>
          ))}
        </div>
      </CommonPopup>
    </div>
  );
}
